import getAccessTokenOnBehalfOfAddin from './getAccessTokenOnBehalfOfAddin';
import { hideSsoDialog } from 'owa-addins-store';

export default function hideDialogAndTriggerTokenFlowOnSuccess(
    controlId: string,
    authChallenge: string
) {
    hideSsoDialog();
    getAccessTokenOnBehalfOfAddin(controlId, authChallenge);
}
